import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SyncIcon from '@material-ui/icons/Sync';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BookIcon from '@material-ui/icons/Book';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import EventNoteIcon from '@material-ui/icons/EventNote';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/CheckBoxOutlineBlankRounded';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ForwardIcon from '@material-ui/icons/Forward';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import { CardHeader, Divider, Tooltip, List, CircularProgress, Dialog, DialogContent, Slide, DialogContentText, DialogActions, LinearProgress, Snackbar, SnackbarContent, AppBar, IconButton, Toolbar, ListItem, ListItemText, ListItemIcon, Checkbox, TextField, Select, MenuItem, OutlinedInput, ListItemSecondaryAction } from '@material-ui/core';

import PilihSekolah from './PilihSekolah';
import Timeline from '../RaporMutu/Timeline';

// import CloseIcon from '@material-ui/icons/Close';
// // import Pagination from "material-ui-flat-pagination";

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const styles = theme => ({
    layoutRoot: {},
    root: {
        flexGrow: 1,
    },
    paperKepsekIsiKuesioner: {
        background: '#E65100',
        borderRadius: '0px',
        color: 'white',
        textAlign: 'center'
    },
    PaperKonfirmasiInstrumen: {
        background: '#558B2F',
        borderRadius: '0px',
        color: 'white',
        textAlign: 'center'
    },
    textPaperKonfirmasiInstrumen: {
        color: 'white'
    },
    judulKemajuanTotal : {
        fontSize: '18px'
    },
    badgeIndividual: {
        border: '0px solid #ccc',
        minHeight: 45,
        minWidth: 40,
        marginRight: 5,
        marginBottom: 5
    },
    facebook2: {
        color: '#eef3fd',
        animationDuration: '550ms',
        position: 'absolute',
        // left: 0,
    },
    ceklis_pengguna: {},
    offset: 0
});

class Beranda extends Component {

    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         error: null,
    //         isLoaded: false,
    //         nama: 'Tamu',
    //         namaMarkup: [],
    //         peran_id_str: '',
    //         routeParams: {
    //             sekolah_id: null,
    //             tahun: localStorage.getItem('tahun')
    //         },
    //         kemajuan_total : 0,
    //         badge_stat: {
    //             1: '1_a',
    //             2: '2_a',
    //             3: '3_a',
    //             4: '4_a',
    //             5: '5_a',
    //             6: '6_a',
    //             7: '7_a',
    //             8: '8_a',
    //             9: '9_a',
    //         },
    //         kontenUtama: 'konten-utama'
    //     };

    //     this.buatSekolahButton = this.buatSekolahButton.bind(this);
    //     this.gotoProfilPengguna = this.gotoProfilPengguna.bind(this);
    // }

    state = {
        error: null,
        isLoaded: false,
        nama: 'Tamu',
        namaMarkup: [],
        peran_id_str: '',
        routeParams: {
            sekolah_id: null,
            tahun: localStorage.getItem('tahun')
        },
        kemajuan_total : 0,
        badge_stat: {
            1: '1_a',
            2: '2_a',
            3: '3_a',
            4: '4_a',
            5: '5_a',
            6: '6_a',
            7: '7_a',
            8: '8_a',
            9: '9_a',
        },
        kontenUtama: 'konten-utama',
        kepsekIsiKuesioner: true,
        dialogOpen: false, 
        dialogText: '', 
        buttonDialogText: '',
        dialogUrl: '',
        dialogOpenProgres: false,
        completed: 0,
        hiddenButtonProgres: true,
        jenisProgres: 'indeterminate',
        tampilPeringatan: false,
        tampilSelesai: true,
        dialogOpenDebugging: false,
        dialogTextDebugging: '',
        vertical: 'bottom',
        horizontal: 'right',
        open: false,
        snackbarText: 'Pengecekan data jawaban pengguna (Anda dapat menutup menu beranda dan pindah ke menu lain. Proses ini akan berjalan di background)......',
        tampilButtonDialog: 'block',
        dialogHitungTotalopen: false,
        dialogHitungKandidatOpen: false,
        cek_selesai : {},
        jumlah_selesai: 0,
        persen_selesai: 0,
        button_tutup: true,
        buffer_value: 50,
        pengguna_mengerjakan: {
            total: 0,
            rows: []
        },
        pengguna_mengerjakan_kandidat: {
            total: 0,
            rows: []
        },
        peran_id: 99,
        dialogPerubahan: false,
        dialogBatasWaktu: false
    };

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};

        if(Number(pengguna.peran_id) === 10){
            arrReturn.responden = 'kepsek';
        }else if(Number(pengguna.peran_id) === 12 || Number(pengguna.peran_id) === 90){
            arrReturn.responden = 'siswa';
        }else if(Number(pengguna.peran_id) === 13){
            arrReturn.responden = 'pengawas';
        }else if(Number(pengguna.peran_id) === 14){
            arrReturn.responden = 'komite';
        }else if(Number(pengguna.peran_id) === 53){
            arrReturn.responden = 'guru';
        }
        
        // if(Number(sekolah.bentuk_pendidikan_id) === 5){
        //     arrReturn.jenjang = 'SD';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
        //     arrReturn.jenjang = 'SMP';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
        //     arrReturn.jenjang = 'SMA';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
        //     arrReturn.jenjang = 'SMK';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
        //     arrReturn.jenjang = 'SLB';
        // }

        if(Number(sekolah.bentuk_pendidikan_id) === 5){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 53){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 54){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 55){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
            arrReturn.jenjang = 'SMK';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    componentDidMount(){

        // console.log(Date.now())
        
        let myDate = "22-10-2021"
        myDate = myDate.split("-")
        let newDate = new Date( myDate[2], myDate[1] - 1, myDate[0])
        
        let myDateTest = "12-10-2020"
        myDateTest = myDateTest.split("-")
        let newDateTest = new Date( myDateTest[2], myDateTest[1] - 1, myDateTest[0])

        // console.log(parseInt(Date.now()))
        console.log(parseInt(newDateTest.getTime()))
        console.log(parseInt(newDate.getTime()))

        // if( parseInt(newDateTest.getTime()) > parseInt(newDate.getTime()) ){
        if( parseInt(Date.now()) > parseInt(newDate.getTime()) ){
            // console.log('lewat waktunya')

            this.setState({
                ...this.state,
                dialogBatasWaktu: true
            })
        
        }else{

            this.props.setJudul('Beranda');

            this.setState({
                kontenUtama: 'konten-utama-aktif'
            });
            window.addEventListener("beforeunload", (ev) => 
            {  
                ev.preventDefault();
                return ev.returnValue = 'Apakah Anda yakin ingin menutup Aplikasi EDS? Dimungkinkan ada proses yang belum terselesaikan oleh aplikasi';
            });
    
            // console.log(localStorage.getItem('user'));
    
            if(localStorage.getItem('user').length > 0){
                const user = JSON.parse(localStorage.getItem('user'));
    
                if(Number(user.peran_id) === 13){
                    if(localStorage.getItem('sekolah_id_pengawas') === null || localStorage.getItem('sekolah_id_pengawas') === ''){
                        this.props.setDialogSekolahBinaan(true);
                    }
                }
    
                // console.log(user.peran_id);
    
                if(Number(user.peran_id) === 10){
                    // this.setState({
                    //     ...this.state,
                    //     peran_id_str: 'Kepala Sekolah (Menggunakan Akun Operator Sekolah Dapodik)'
                    // });
                    // this.state.peran_id_str = 'Kepsek (Akun Operator Sekolah)';
                    this.setState({
                        peran_id_str: 'Kepsek (Akun Operator Sekolah)'
                    })
    
                    this.setState({
                        ...this.state,
                        kepsekIsiKuesioner: true
                        // kepsekIsiKuesioner: false
                    });
    
                    this.props.setKepsekIsiKuesioner(true);
                    // this.props.setKepsekIsiKuesioner(false);
                }else if(Number(user.peran_id) === 13){
                    this.setState({ peran_id_str: 'Pengawas' });
                }else if(Number(user.peran_id) === 14){
                    this.setState({ peran_id_str: 'Komite Sekolah' });
                }else if(Number(user.peran_id) === 12 || Number(user.peran_id) === 90 ){
                    this.setState({ peran_id_str: 'Peserta Didik' });
                }else if(Number(user.peran_id) === 53 ){
                    this.setState({ peran_id_str: 'Guru' });
                }
    
                // console.log(this.state.peran_id_str);
    
                this.setState({
                    nama: user.nama,
                    email: user.email
                });
    
                let namaMarkup = user.nama.split(" ");
    
                // let namaMarkupStr = '';
    
                // console.log(namaMarkup);
    
                // for (let urutan = 0; urutan < 2; urutan++) {
                // // for (let urutan = 0; urutan < namaMarkup.length; urutan++) {
                //     let str = '';
                //     if(urutan === 0){
                //         str = "<i>" + namaMarkup[urutan] + "</i>";
                //     }else{
                //         str = "<b>" + namaMarkup[urutan] + "</b>";
                //     }
    
                //     namaMarkupStr = namaMarkupStr + " " + str;
                // }
    
                // console.log(namaMarkupStr);
                // this.setState({
                //     namaMarkup: namaMarkup
                // });
                // console.log(this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang);
    
                this.setState({
                    ...this.state,
                    namaMarkup: namaMarkup,
                    nama: user.nama,
                    routeParams: {
                        ...this.state.routeParams,
                        sekolah_id: user.sekolah_id,
                        pengguna_id: user.pengguna_id,
                        token: localStorage.getItem('jwt_token'),
                        instrumen_id: localStorage.getItem('instrumen_id'),
                        start:0,
                        limit: 20,
                        load_children: 0,
                        tingkat_instrumen: 2,
                        tahun_ajaran_id: localStorage.getItem('tahun'),
                        tahun: localStorage.getItem('tahun'),
                        // kontenUtama: 'konten-utama-aktif'
                    }
                }, () => {
                    // this.props.getKonfirmasiSelesai(this.state.routeParams).then((result)=>{
                    //     // console.log(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
                    //     this.props.setKunciKonfirmasiInstrumen(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
                    // });
                    // this.props.setLoadingBesar(true);
                    // this.props.setLoading('block');

                    // // dikomen gara2 lama
                    // if(localStorage.getItem('baru_registrasi') === '1'){
    
                    //     this.props.cekJawabanUtamaSemua(this.state.routeParams).then((result)=>{
        
                    //         if(this.props.cek_jawaban_utama_semua.total > 0){
        
                    //             this.handleClickDialogOpen('Sehubungan dengan perubahan struktur dan alur proses pada versi 2019.12 keatas, terdapat jawaban kuesioner pengguna sekolah Anda yang belum terkonversi. Silakan klik tombol di bawah ini untuk mengonversi jawaban tersebut.', 'Konversi Jawaban')
        
                    //         }else{
        
                    //             this.setState({
                    //                 // open: true,
                    //                 dialogOpen: true,
                    //                 dialogText: 'Anda baru saja melakukan registrasi. Mohon tunggu beberapa saat sementara aplikasi mengecek data pengguna ........',
                    //                 tampilButtonDialog: 'none'
                    //             },()=>{
        
                    //                 this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                    //                 // this.props.pecahJawabanUtamaSemua(this.state.routeParams).then((result)=>{
                    //                     // this.props.setLoadingBesar(false);
                    //                     // this.props.setLoading('none');
                    //                     this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
        
                    //                         // this.setState({
                    //                         //     // open:false,
                    //                         //     snackbarText: "Proses Berhasil!"
                    //                         // });
        
                    //                         //diulang lagi kedua kali
                    //                         this.props.cekJawabanUtamaSemua(this.state.routeParams).then((result)=>{
        
                    //                             if(this.props.cek_jawaban_utama_semua.total > 0){
                            
                    //                                 this.handleClickDialogOpen('Sehubungan dengan perubahan struktur dan alur proses pada versi 2019.12 keatas, terdapat jawaban kuesioner pengguna sekolah Anda yang belum terkonversi. Silakan klik tombol di bawah ini untuk mengonversi jawaban tersebut.', 'Konversi Jawaban')
                            
                    //                             }else{
                            
                    //                                 this.setState({
                    //                                     // open: true
                    //                                     dialogOpen: true,
                    //                                     dialogText: 'Anda baru saja melakukan registrasi. Mohon tunggu beberapa saat sementara aplikasi mengecek data pengguna ........',
                    //                                     tampilButtonDialog: 'none'
                    //                                 },()=>{
                            
                    //                                     this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                    //                                     // this.props.pecahJawabanUtamaSemua(this.state.routeParams).then((result)=>{
                    //                                         // this.props.setLoadingBesar(false);
                    //                                         // this.props.setLoading('none');
                    //                                         this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                            
                    //                                             this.setState({
                    //                                                 // open:false,
                    //                                                 snackbarText: "Proses Berhasil!",
                    //                                                 dialogOpen: false
                    //                                             },()=>{
                    //                                                 localStorage.setItem('baru_registrasi','0');
                    //                                             });
                            
                    //                                         });
                                
                    //                                     });
                            
                    //                                 })
                            
                    //                             }
                            
                    //                         });
        
                    //                     });
            
                    //                 });
        
                    //             })
        
                    //         }
        
                    //     });
    
                    // }
    
    
                    
                    this.props.getKepalaSekolah(this.state.routeParams);
    
                    this.props.getSekolah(this.state.routeParams).then((result)=>{
                        // console.log(this.props.sekolah);
    
                        this.setState({
                            ...this.state,
                            routeParams: {
                                ...this.state.routeParams,
                                jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                                responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
                            }
                        }, ()=>{
    
                            this.props.getKemajuanTotal(this.state.routeParams).then((result)=>{
                                // console.log(this.props.sekolah);
                                // let ceks = 0;
    
                                const array = this.props.kemajuan_total.rows;
                                for (let index = 0; index < array.length; index++) {
                                    const option = array[index];
                                    
                                    if(Number(option.peran_id) === 99){
                                        this.setState({
                                            ...this.state,
                                            kemajuan_total: option.persentase
                                        });
                                    }
                                }
                                // this.props.kemajuan_total.rows.map((option)=>{
                                //     if(Number(option.peran_id) === 99){
                                //         this.setState({
                                //             ...this.state,
                                //             kemajuan_total: option.persentase
                                //         });
                                //     }
    
                                //     if(Number(option.peran_id) === 53 && option.persentase === 100){
                                //         ceks++;
                                //     }
    
                                //     if(Number(option.peran_id) === 90 && option.persentase === 100){
                                //         ceks++;
                                //     }
    
                                //     if(Number(option.peran_id) === 14 && option.persentase === 100){
                                //         ceks++;
                                //     }
                                // });
    
                                // // console.log(ceks);
    
                                // if(ceks === 3){
                                //     this.setState({
                                //         ...this.state,
                                //         kepsekIsiKuesioner: true
                                //     });
    
                                //     this.props.setKepsekIsiKuesioner(true);
                                // }
                            });
            
                            this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
                                // alert('tes');
                                let persenTotal = 0;
                                let rowTotal = 0;
                                for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
                                    const element = this.props.rekap_kemajuan.rows[index];
                                    
                                    // persenTotal = persenTotal+Number(element.persentase);
                                    if(element.jumlah_total > 0){
    
                                        persenTotal = persenTotal+Number(element.persentase);
                                        rowTotal++;
                                    }
                    
                                }
                    
                                let persenRata = (persenTotal/rowTotal).toFixed(1);
                    
                                this.setState({
                                    ...this.state,
                                    persenRata: persenRata,
                                    kontenUtama: 'konten-utama'
                                });
                            });  
                        });
                        
                    });
                    
                    this.props.getBadgePengguna(this.state.routeParams);
                });
    
                // this.setState({
                //     ...this.state,
                //     routeParams: {
                //         ...this.state.routeParams,
                //         pengguna_id: user.pengguna_id,
                //         token: localStorage.getItem('jwt_token')
                //     }
                // }, () => {
                //     this.props.getKonfirmasiSelesai(this.state.routeParams).then((result)=>{
                //         // console.log(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
                //         this.props.setKunciKonfirmasiInstrumen(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
                    
                //     });
    
                // });
        
            }else{
                this.setState({
                    nama: 'Tamu'
                });
            }
    
            if(localStorage.getItem('sekolah') === '' || !localStorage.getItem('sekolah')){
                // alert('sekolah belum dipilih');
    
            }
        }


        // this.setState({
        //     ...this.state,
        //     routeParams: {
        //         ...this.state.routeParams,
        //         start:0,
        //         limit: 20,
        //         pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
        //         load_children: 0,
        //         tingkat_instrumen: 2,
        //         tahun_ajaran_id: localStorage.getItem('tahun'),
        //         tahun: localStorage.getItem('tahun'),
        //         sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
        //         jenjang: null,
        //         responden: null
        //     }
        // }, ()=>{

        //     this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
        //         // alert('tes');
        //         let persenTotal = 0;
        //         let rowTotal = 0;
        //         for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
        //             const element = this.props.rekap_kemajuan.rows[index];
                    
        //             // persenTotal = persenTotal+Number(element.persentase);
        //             if(element.jumlah_total > 0){
        //                 persenTotal = persenTotal+Number(element.persentase);
        //                 rowTotal++;
        //             }
    
        //         }
    
        //         let persenRata = (persenTotal/rowTotal).toFixed(2);
    
        //         this.setState({
        //             ...this.state,
        //             persenRata: persenRata
        //         });
        //     })

        // })


        // fetch('http://foto2.data.kemdikbud.go.id/getImage/69786627/1.jpg',{
        //     method: 'GET'
        // })
        // .then(res => res.blob())
        // .then(
        // (images) => {
        //     var outside = URL.createObjectURL(images)
        //     console.log(outside)
        // });
    }

    buatSekolahButton = (event, data) => {

        this.goTolink('PeringkatPengisian');

        // console.log(Router);

        // console.log(this.props);
        
        // window.location.reload(tambahSekolah);
        // this.props.history.push('/tambahSekolah');

    }

    buatAndaButton = (event, data) => {

        this.goTolink('PerangkatKuesioner');

        // console.log(Router);

        // console.log(this.props);
        
        // window.location.reload(tambahSekolah);
        // this.props.history.push('/tambahSekolah');

    }

    gotoProfilPengguna = (event, data) => {

        this.props.history.push('/profilPengguna');

    }

    handleClickDialogOpen = (dialogText, buttonText, url) => {

        this.setState({ 
            dialogOpen: true, 
            dialogText: dialogText, 
            buttonDialogText: buttonText,
            dialogUrl: url
        });

    }

    Transition = (props) => {
        return <Slide direction="up" {...props} />;
    }

    prosesJawaban = () => {
        
        this.setState({
            dialogOpen: false,
            dialogOpenProgres: true
        },()=>{

            // let selesai = 0;


            // this.props.cek_jawaban_utama_semua.rows.map((option)=>{

            //     // console.log(option.leng)
            //     // console.log(option.pengguna_id);
            //     // this.setState({
            //     //     ...this.state,
            //     //     routeParams: {
            //     //         ...this.state.routeParams,
            //     //         pengguna_id: option.pengguna_id,
            //     //         mandiri: 1
            //     //     }
            //     // },()=>{
                    this.props.simpanJawabanUtamaSemua(this.state.routeParams).then((result)=>{
            //             // setTimeout(() => {
                            
            //             this.setState({
            //                 completed: (((Number(this.state.completed)+1) / this.props.cek_jawaban_utama_semua.total) * 100)
            //             });
            //             // console.log( (((Number(this.state.completed)+1) / this.props.cek_jawaban_utama_semua.total) * 100) );

            //             // }, (this.state.completed + 1000) );
                        this.setState({
                            hiddenButtonProgres: false,
                            jenisProgres: 'determinate',
                            completed: 100,
                            tampilPeringatan: true,
                            tampilSelesai: false
                        },()=>{

                        });
                    });
            //         // console.log(this.state.routeParams);
            //     // });
            //     selesai++;
            // });

            // if(selesai === this.props.cek_jawaban_utama_semua.total){
            //     this.setState({
            //         hiddenButtonProgres: false
            //     });
            // }

        });
    }

    loadData = (e, offset) => {
        // this.setState({displayProgres: 'block', isLoaded: false});
        this.setState({
            offset: offset,
            routeParams:{
                ...this.state.routeParams, 
                start:offset
            }
        },()=>{
            this.props.getPenggunaMengerjakan(this.state.routeParams).then((result)=>{

            });
        });

    }

    handleDialogCloseProgres = () => {
        this.setState({ dialogOpenProgres: false });
    };

    handleDialogCloseDebugging = () => {
        this.setState({ dialogOpenDebugging: false });
    };

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};

        if(Number(pengguna.peran_id) === 10){
            arrReturn.responden = 'kepsek';
        }else if(Number(pengguna.peran_id) === 12 || Number(pengguna.peran_id) === 90){
            arrReturn.responden = 'siswa';
        }else if(Number(pengguna.peran_id) === 13){
            arrReturn.responden = 'pengawas';
        }else if(Number(pengguna.peran_id) === 14){
            arrReturn.responden = 'komite';
        }else if(Number(pengguna.peran_id) === 53){
            arrReturn.responden = 'guru';
        }
        
        // if(Number(sekolah.bentuk_pendidikan_id) === 5){
        //     arrReturn.jenjang = 'SD';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
        //     arrReturn.jenjang = 'SMP';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
        //     arrReturn.jenjang = 'SMA';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
        //     arrReturn.jenjang = 'SMK';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
        //     arrReturn.jenjang = 'SLB';
        // }

        if(Number(sekolah.bentuk_pendidikan_id) === 5){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 53){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 54){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 55){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
            arrReturn.jenjang = 'SMK';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    pecahJawabanUtama = (nn, total) => {
        // console.log(nn);

        if(nn < total){
            
            // console.log(this.props.pengguna_mengerjakan.rows[nn].pengguna_id);

            this.setState({
                ...this.state,
                routeParams: {
                    ...this.state.routeParams,
                    load_children: 1,
                    tingkat_instrumen: 1,
                    pengguna_id: this.props.pengguna_mengerjakan.rows[nn].pengguna_id,
                    sekolah_id: this.props.pengguna_mengerjakan.rows[nn].sekolah_id,
                    tahun_ajaran_id: 2020,
                    jenjang: this.getJenjangResponden(this.props.sekolah, this.props.pengguna_mengerjakan.rows[nn]).jenjang,
                    responden: this.getJenjangResponden(this.props.sekolah, this.props.pengguna_mengerjakan.rows[nn]).responden,
                    instrumen_id: localStorage.getItem('instrumen_id'),
                    media_id: 1,
                    kelompok_kode: '["A", "B", "C", "D", "E", "F", "G", "H"]'
                },
                pengguna_mengerjakan: {
                    total: 0,
                    rows: [
                        this.props.pengguna_mengerjakan.rows[nn],
                        ...this.state.pengguna_mengerjakan.rows
                    ]
                }
            },()=>{

                this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                    // this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                    //     this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                    //         this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{
                                this.props.hitungRekapKemajuan(this.state.routeParams).then((result)=>{
                                    
                                    this.setState({
                                        cek_selesai: {
                                            ...this.state.cek_selesai,
                                            [this.props.pengguna_mengerjakan.rows[nn].pengguna_id]: 1
                                        },
                                        jumlah_selesai: (parseFloat(this.state.jumlah_selesai)+1),
                                        persen_selesai: (((parseFloat(this.state.jumlah_selesai)+1)/parseFloat(this.props.pengguna_mengerjakan.total) * 100)).toFixed(2)
                                    },()=>{

                                        // nn = nn+1;
                                        
                                        this.pecahJawabanUtama((parseFloat(nn)+1), parseFloat(total));

                                    });
                                });
                    //         });
                    //     });
                    // });
                });
                
            });


        }else{

            this.setState({
                button_tutup: false,
                routeParams: {
                    ...this.state.routeParams,
                    load_children: 1,
                    tingkat_instrumen: 1,
                    pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                    sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                    tahun_ajaran_id: 2020,
                    jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                    responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                    instrumen_id: localStorage.getItem('instrumen_id'),
                    media_id: 1,
                    kelompok_kode: '["A", "B", "C", "D", "E", "F", "G", "H"]'
    
                }
            },()=>{
                this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
                    let persenTotal = 0;
                    let rowTotal = 0;
                    for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
                        const element = this.props.rekap_kemajuan.rows[index];
                        
                        // persenTotal = persenTotal+Number(element.persentase);
                        if(element.jumlah_total > 0){
                            persenTotal = persenTotal+Number(element.persentase);
                            rowTotal++;
                        }
        
                    }
        
                    let persenRata = (persenTotal/rowTotal).toFixed(1);
        
                    this.setState({
                        ...this.state,
                        persenRata: persenRata,
                        kontenUtama: 'konten-utama'
                    });
                });  
            });

            
        }

    }

    handleCloseDialogPerubahan = () => {
        this.setState({
            dialogPerubahan: false
        })
    }

    pecahRoot = (nn, total) => {
        console.log('rootnya');

        // let nn = 0;
        // let total = 10;

        this.pecahJawabanUtama(nn, total);
    }

    hitungTotalRekapKemajuanKandidat = () => {
        this.setState({
            dialogHitungKandidatOpen: true,
            offset: 0,
            routeParams:{
                ...this.state.routeParams,
                pengguna_id: null,
                where_in: null,
                start: 0,
                limit: 20000
            },
            ceklis_pengguna: {}
        },()=>{
            this.props.getPenggunaMengerjakan(this.state.routeParams).then((result)=>{
                this.setState({
                    pengguna_mengerjakan_kandidat: this.props.pengguna_mengerjakan
                });
            });
        });
    }

    hitungTotalRekapKemajuan = () => {

        let inStr = '';

        for (let property in this.state.ceklis_pengguna) {
            if (this.state.ceklis_pengguna.hasOwnProperty(property)) {
                if(this.state.ceklis_pengguna[property] === true){
                    inStr += property + ",";
                }
            }
        }

        console.log(inStr.substring(0, inStr.length-1));
        // console.log(JSON.stringify(this.state.ceklis_pengguna));

        // return true;

        // alert('tes');
        this.setState({
            dialogHitungTotalopen: true,
            dialogHitungKandidatOpen: false,
            cek_selesai : {},
            jumlah_selesai: 0,
            persen_selesai: 0,
            button_tutup: true,
            routeParams: {
                ...this.state.routeParams,
                pengguna_id: null,
                start:0,
                limit:1000000,
                where_in: inStr.substring(0, inStr.length-1)
            },
            pengguna_mengerjakan: {
                rows: []
            }
        },()=>{
            this.props.getPenggunaMengerjakan(this.state.routeParams).then((result)=>{

                let arrCekSelesai = {};

                // this.props.pengguna_mengerjakan.rows.map((option)=>{
                //     arrCekSelesai[option.pengguna_id] = 0;
                // });

                const array = this.props.pengguna_mengerjakan.rows;
                for (let index = 0; index < array.length; index++) {
                    const option = array[index];
                    arrCekSelesai[option.pengguna_id] = 0;
                }

                console.log(arrCekSelesai);

                this.setState({
                    cek_selesai: arrCekSelesai,
                    persen_selesai: 0
                },()=>{
                    // console.log(this.state);
                    // let nn = 1;

                    this.pecahRoot(0,parseFloat(this.props.pengguna_mengerjakan.total));

                    // this.props.pengguna_mengerjakan.rows.map((option)=>{
                        
                    //     //proses per pengguna di sini
                        
                    //     this.setState({
                    //         ...this.state,
                    //         routeParams: {
                    //             ...this.state.routeParams,
                    //             load_children: 1,
                    //             tingkat_instrumen: 1,
                    //             pengguna_id: option.pengguna_id,
                    //             sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                    //             tahun_ajaran_id: 2020,
                    //             jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                    //             responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                    //             instrumen_id: localStorage.getItem('instrumen_id'),
                    //             media_id: 1,
                    //             kelompok_kode: '["A", "B", "C", "D", "E", "F", "G", "H"]'
                
                    //         },
                    //         cek_selesai: {
                    //             ...this.state.cek_selesai,
                    //             [option.pengguna_id]: 1
                    //         },
                    //         jumlah_selesai: (parseFloat(this.state.jumlah_selesai)+1),
                    //         persen_selesai: (((parseFloat(this.state.jumlah_selesai)+1)/parseFloat(this.props.pengguna_mengerjakan.total) * 100)).toFixed(2)
                    //     },()=>{

                    //         this.props.pecahJawabanUtama(this.state.routeParams).then((result)=>{

                    //             this.props.hitungRekapKemajuan(this.state.routeParams).then((result)=>{
                                    
                    //             });

                    //         });
                            
                    //     });

                    // });
                    
                });

            });
        });
    }

    bufferValue = () => {

    }

    handleClose = () => {
        this.setState({
            dialogHitungTotalopen: false
        });
    }
    
    handleCloseKandidat = () => {
        this.setState({
            dialogHitungKandidatOpen: false
        });
    }

    ceklisPengguna = (pengguna_id) => (e,checked) => {
        // alert('tes')
        // console.log(pengguna_id);
        // console.log(checked);
        this.setState({
            ceklis_pengguna: {
                ...this.state.ceklis_pengguna,
                [pengguna_id]: checked
            }
        },()=>{
            console.log(this.state);
        });
    }

    cariPengguna = (e) => {
        // console.log(e.currentTarget.value);
        // console.log(b);

        this.setState({
            offset: 0,
            routeParams:{
                ...this.state.routeParams, 
                start:0,
                keyword: e.currentTarget.value
            }
        },()=>{
            this.props.getPenggunaMengerjakan(this.state.routeParams).then((result)=>{

            });
        });
    }

    handleLogoutButton = () => {
        localStorage.setItem('jwt_token', '');
        localStorage.setItem('access_token', '');
        localStorage.setItem('user', '');
        localStorage.setItem('pengguna_id_ops', '');
        localStorage.setItem('aslinya_ops', '');

        window.location.href="/";
    }

    render()
    {
        const {classes} = this.props;
        const { vertical, horizontal } = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                // header={
                    
                // }
                // contentToolbar={
                //     <div className="px-24"><h4>Content Toolbar</h4></div>
                // }
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                    <div className={this.state.kontenUtama}>
                        {/* <Paper className={"p-8 " + classes.paperKepsekIsiKuesioner}>
                            <Typography variant="subheading" className={classes.textPaperKonfirmasiInstrumen}>
                                <span style={{fontSize: '20px', fontWeight: 'bold'}}>PERHATIAN!</span><br/>
                                <Typography style={{fontSize: '12px', color:'white'}}>Aplikasi EDS Dikdasmen sedang mengalami kendala dalam hal kapasitas penggunaan aplikasi dan Kami sedang berusaha menyempurnakannya. Selama masa penyempurnaan dan optimasi aplikasi, Kami memohon pengertian dan kesabarannya. Pada tanggal 10 November 2019, Kami perkirakan aplikasi sudah dapat digunakan secara optimal</Typography>
                                <Typography style={{fontSize: '12px', color:'white'}}>Terima kasih</Typography>
                                
                            </Typography>
                        </Paper> */}
                        {/* {localStorage.getItem('sekolah_id_pengawas') === null || localStorage.getItem('sekolah_id_pengawas') === '' && <PilihSekolah/>} */}
                        <PilihSekolah/>

                        <Dialog
                            open={this.state.dialogBatasWaktu}
                            TransitionComponent={this.Transition}
                            keepMounted
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                Aplikasi EDS versi ini telah habis masa berlakunya. Silakan tunggu versi rilis resmi dari aplikasi EDS ini untuk kembali melakukan pengisian instrumen EDS
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleLogoutButton}>
                                    <CloseIcon/> Logout
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Snackbar
                            variant="warning"
                            anchorOrigin={{ 
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            key={`${vertical},${horizontal}`}
                            open={this.state.open}
                            // onClose={handleCloseSnack}
                            ContentProps={{
                            'aria-describedby': 'message-id',
                            }}
                            style={{top:'28px'}}
                            >
                            <SnackbarContent
                                className="warning"
                                message={<span id="message-id">{this.state.snackbarText}</span>}
                            />
                        </Snackbar>
                        
                        <Dialog
                            open={this.state.dialogOpenProgres}
                            TransitionComponent={this.Transition}
                            keepMounted
                            // onClose={this.handleDialogCloseProgres}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <LinearProgress style={{width: '400px', height:'25px'}} variant={this.state.jenisProgres} value={this.state.completed} />
                                {/* {this.state.completed}% */}
                                <span hidden={this.state.tampilPeringatan}>Jangan ditutup sebelum proses selesai!</span>
                                <span hidden={this.state.tampilSelesai}>Proses selesai</span>
                            </DialogContent>
                            <DialogActions>
                                <Button hidden={this.state.hiddenButtonProgres} onClick={this.handleDialogCloseProgres}>
                                    <CloseIcon/> Selesai dan Tutup
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={this.state.dialogPerubahan}
                            TransitionComponent={this.Transition}
                            keepMounted
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent style={{width:'100%'}}>
                                {/* <iframe style={{width:'100%'}} src="http://localhost:1745/pembaruan.txt"></iframe> */}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCloseDialogPerubahan}>
                                    <CloseIcon/> Tutup
                                </Button>
                            </DialogActions>
                        </Dialog>
                        
                        <Dialog
                            open={this.state.dialogOpen}
                            TransitionComponent={this.Transition}
                            keepMounted
                            onClose={this.handleDialogClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <DialogContentText>
                                    {this.state.dialogText}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.prosesJawaban} style={{display:this.state.tampilButtonDialog}}>
                                    <ForwardIcon /> {this.state.buttonDialogText}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={this.state.dialogOpenDebugging}
                            TransitionComponent={this.Transition}
                            keepMounted
                            onClose={this.handleDialogCloseDebugging}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent>
                                <DialogContentText>
                                    Debugging:
                                    <br/>
                                    {this.state.dialogTextDebugging}
                                </DialogContentText>
                            </DialogContent>
                        </Dialog>

                        <Dialog fullScreen open={this.state.dialogHitungKandidatOpen} onClose={this.handleCloseKandidat} TransitionComponent={this.Transition}>
                            <AppBar position="static" className={classes.appBar}>
                                <Toolbar style={{minHeight:'0px'}}>
                                    <IconButton edge="start" color="inherit" onClick={this.handleCloseKandidat} aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" className={classes.title}>
                                        Pilih Responden {this.props.sekolah.nama}
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <Paper className="p-8">
                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <i>Ceklis pengguna/responden yang akan dihitung kemajuannya.<br/>
                                        Data responden yang tampil adalah responden yang telah menjadi <b>kandidat pengisi instrumen</b> di menu manajemen pengguna.</i><br/>
                                        <i>Apabila ada data responden yang belum tampil pada halaman ini, silakan buka <a href="/ManajemenPengguna">manajemen pengguna</a> dan ceklis responden yang bersangkutan menjadi kandidat pengisi instrumen</i>
                                        <Divider/>
                                    </Grid>
                                    {/* <Grid item xs={3}>
                                        // <Pagination
                                        limit={20}
                                        offset={this.state.offset}
                                        total={this.props.pengguna_mengerjakan.total}
                                        innerButtonCount={1}
                                        style={{width: '100%'}}
                                        onClick={this.loadData}
                                        />
                                    </Grid> */}
                                    <Grid item xs={4}>
                                        <Select
                                            placeholder="Saring Jenis Responden"
                                            variant="outlined"
                                            size="small"
                                            value={this.state.routeParams.peran_id}
                                            // value={1}
                                            input={
                                                <OutlinedInput
                                                style={{width: '100%'}}
                                                labelWidth={180}
                                                id="peran_id"
                                                name="peran_id"
                                                placeholder="Saring Jenis Responden"
                                                onChange={this.handleChange}
                                                // style={{padding:'8px'}}
                                                className="inputFilter"
                                                // defaultValue={this.state.data.peran}
                                                />
                                            }
                                            onChange={(event) => {

                                                // alert('tes');
                                                this.setState({
                                                    ...this.state,
                                                    routeParams: { 
                                                        ...this.state.routeParams,
                                                        peran_id: event.target.value
                                                    }
                                                },()=>{
                                                    this.props.getPenggunaMengerjakan(this.state.routeParams);
                                                })
                                                
                                            }}
                                            name="peran_id"
                                            style={{width: '100%'}}
                                            >
                                            <MenuItem value={99}>
                                                Semua
                                            </MenuItem>
                                            <MenuItem value={10}>Operator Sekolah</MenuItem>
                                            <MenuItem value={53}>Guru</MenuItem>
                                            <MenuItem value={90}>Peserta Didik</MenuItem>
                                            <MenuItem value={14}>Komite Sekolah</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField size="small" className="inputFilter" variant="outlined" style={{width:'100%'}} placeholder="Cari Dengan kata kunci ..." onChange={this.cariPengguna} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button variant="raised" size="large" color="primary" onClick={()=>{this.props.history.push('/ManajemenPengguna')}}>
                                            PILIH KANDIDAT RESPONDEN
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <div style={{height:'100%', overflow:'auto', border:'0px solid red'}}>
                                <List>
                                {this.props.pengguna_mengerjakan.rows.map((option)=>{
                                    let kemajuan_rata = 0;
                                    let total = 0;

                                    for (let indexKemajuan = 0; indexKemajuan < option.kemajuan.rows.length; indexKemajuan++) {
                                        const element = option.kemajuan.rows[indexKemajuan];

                                        switch (Number(option.peran_id)) {
                                            case 10:
                                                if(Number(element.kepsek) === 1){
                                                    kemajuan_rata = parseFloat(kemajuan_rata) + parseFloat(element.persentase);
                                                    total = total+1;
                                                }
                                                break;
                                            case 53:
                                                if(Number(element.guru) === 1){
                                                    kemajuan_rata = parseFloat(kemajuan_rata) + parseFloat(element.persentase);
                                                    total = total+1;
                                                }
                                                break;
                                            case 90:
                                                if(Number(element.siswa) === 1 && element.kode !== 'D'){
                                                    kemajuan_rata = parseFloat(kemajuan_rata) + parseFloat(element.persentase);
                                                    total = total+1;
                                                }
                                                break;
                                            case 14:
                                                if(Number(element.komite) === 1 && element.kode !== 'C'){
                                                    kemajuan_rata = parseFloat(kemajuan_rata) + parseFloat(element.persentase);
                                                    total = total+1;
                                                }
                                                break;
                                            default:
                                                if(Number(element.kepsek) === 1){
                                                    kemajuan_rata = parseFloat(kemajuan_rata) + parseFloat(element.persentase);
                                                    total = total+1;
                                                }
                                                break;
                                        }
                                        
                                    }

                                    kemajuan_rata = kemajuan_rata / total;

                                    return(
                                        <ListItem style={{borderBottom:'1px solid #ccc', padding:'0px'}}>
                                            <Checkbox onChange={this.ceklisPengguna(option.pengguna_id)} />
                                            <ListItemText primary={option.nama + " ("+option.email+")"} secondary={option.peran + " - Tanggal Hitung Terakhir: " + option.tanggal}/>
                                            <ListItemSecondaryAction>
                                                <b style={{fontSize:'20px'}}>{kemajuan_rata.toFixed(1)}%</b>
                                            </ListItemSecondaryAction>
                                            {/* {this.state.cek_selesai[option.pengguna_id] === 0 && <span>Memroses data kemajuan ... </span>}
                                            {this.state.cek_selesai[option.pengguna_id] === 0 && <ListItemIcon><CheckIcon style={{color:'gray'}} /></ListItemIcon>}
                                            {this.state.cek_selesai[option.pengguna_id] === 1 && <ListItemIcon><CheckBoxIcon style={{color:'green'}} /></ListItemIcon>} */}
                                            {/* <CheckBoxIcon style={{color:'green'}} /> */}
                                        
                                        </ListItem>
                                    )
                                })}
                                </List>
                            </div>
                            <DialogActions>
                                <Button variant="raised" color="primary" onClick={this.hitungTotalRekapKemajuan}>
                                    Lanjutkan
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog fullScreen open={this.state.dialogHitungTotalopen} onClose={this.handleClose} TransitionComponent={this.Transition}>
                            {/* <DialogContent> */}
                                <AppBar position="static" className={classes.appBar}>
                                    <Toolbar>
                                        <IconButton disabled={this.state.button_tutup} edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" className={classes.title}>
                                            Restore Data dan Hitung Total Kemajuan {this.props.sekolah.nama}
                                        </Typography>
                                        {/* <Button autoFocus color="inherit" onClick={this.handleClose}>
                                        Tutup
                                        </Button> */}
                                    </Toolbar>
                                </AppBar>
                                <Paper className="p-8">
                                    {parseFloat(this.state.persen_selesai) < 100 && <span>Proses sedang berlangsung. Mohon tunggu dan jangan tutup proses ini sebelum selesai!</span>}
                                    {parseFloat(this.state.persen_selesai) >= 100 && <span>Proses selesai dan dapat ditutup</span>}
                                    <br/>
                                    Kemajuan proses: <b style={{fontSize:'18px'}}>{parseFloat(this.state.persen_selesai)}%</b> ({this.state.jumlah_selesai}/{this.props.pengguna_mengerjakan.total})
                                    <br/>
                                    <br/>
                                    <Paper style={{background:'#434343'}}>
                                        <LinearProgress variant="buffer" valueBuffer={(parseFloat(this.state.persen_selesai)+(parseFloat(this.state.persen_selesai)*30/100))} value={parseFloat(this.state.persen_selesai)} color="secondary" style={{height:'15px'}} />
                                    </Paper>
                                </Paper>
                                <div style={{height:'100%', overflow:'auto', border:'0px solid red'}}>
                                    <List>
                                    {this.state.pengguna_mengerjakan.rows.map((option)=>{
                                        return(
                                            <ListItem>
                                                <ListItemText primary={option.nama + " ("+option.email+")"} secondary={option.peran} />
                                                {this.state.cek_selesai[option.pengguna_id] === 0 && <span>Memroses data kemajuan ... </span>}
                                                {this.state.cek_selesai[option.pengguna_id] === 0 && <ListItemIcon><CheckIcon style={{color:'gray'}} /></ListItemIcon>}
                                                {this.state.cek_selesai[option.pengguna_id] === 1 && <ListItemIcon><CheckBoxIcon style={{color:'green'}} /></ListItemIcon>}
                                                {/* <CheckBoxIcon style={{color:'green'}} /> */}
                                            </ListItem>
                                        )
                                    })}
                                        {/* 
                                        <Divider />
                                        <ListItem button>
                                            <ListItemText primary="Default notification ringtone" secondary="Tethys" />
                                        </ListItem> */}

                                    </List>
                                </div>
                            {/* </DialogContent> */}
                        </Dialog>

                        {this.props.kepsek_isi_kuesioner !== true &&
                        <Paper className={"p-8 " + classes.paperKepsekIsiKuesioner}>
                            <Typography variant="subheading" className={classes.textPaperKonfirmasiInstrumen}>
                                <span style={{fontSize: '20px', fontWeight: 'bold'}}>Anda sebagai kepala sekolah belum bisa mengisi kuesioner</span><br/>
                                <Typography style={{fontSize: '12px', color:'white'}}>Sebagai kepala sekolah, Anda baru bisa mengisi kuesioner setelah Guru, Peserta Didik, dan Komite telah selesai mengisi kuesioner sesuai dengan jumlah responden minimalnya</Typography>
                                {/* <Typography style={{fontSize: '12px', color:'white'}}>Untuk mengecek kemajuan masing-masing reponden, silakan buka menu ini</Typography> */}
                            </Typography>
                        </Paper>
                        }
                        {this.props.konfirmasi_instrumen_id !== null &&
                        <Paper className={"p-8 " + classes.PaperKonfirmasiInstrumen}>
                            <Typography variant="subheading" className={classes.textPaperKonfirmasiInstrumen}>
                                <span style={{fontSize: '20px', fontWeight: 'bold'}}>Anda telah menyelesaikan kuesioner PMP!</span><br/>
                                Terima kasih telah turut serta mendukung peningkatan mutu pendidikan di Indonesia!<br/>
                                Sampai jumpa di pemetaan berikutnya!
                            </Typography>
                        </Paper>
                        }
                        
                        {/* <div className="p-8 panelIdentitas" style={{border: '0px solid red', width: '100%', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: 10}}> */}
                        <div className="p-8 panelIdentitas" style={{border: '0px solid red', width: '100%', background: 'white', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: 10}}>
                        {/* <div className="p-8 panelIdentitas" style={{border: '0px solid red', width: '100%', backgroundImage: 'linear-gradient(to right top, #d16ba5, #c777b9, #ba83ca, #aa8fd8, #9a9ae1, #8aa7ec, #79b3f4, #69bff8, #52cffe, #41dfff, #46eefa, #5ffbf1)', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: 10}}> */}
                        {/* <div className="p-8" style={{border: '0px solid red', width: '100%', backgroundImage: 'url(assets/images/backgrounds/library2.jpg)', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: 10}}> */}
                        {/* <div className="p-8" style={{border: '0px solid red', width: '100%', backgroundImage: 'url(http://foto2.data.kemdikbud.go.id/getImage/'+this.props.sekolah.npsn+'/1.jpg)', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', paddingTop: 10}}> */}
                            <Grid container spacing={16} style={{paddingTop: 10}}>
                                <Grid item xs={12}>
                                    <Card className={this.props.classes.card + " wadahSekolah"} style={{width: '100%', paddingBottom: 0, color: 'white', minHeight: 10, padding: 8}}>
                                    {/* <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 0, backgroundColor: '#303030', color: 'white', minHeight: 10, padding: 8}}> */}
                                        {/* <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 0, backgroundColor: '#1A237E', color: 'white', minHeight: 10, padding: 8}}> */}
                                        <Grid container>
                                            <Grid item xs={12} sm={10}>
                                                {Number(JSON.parse(localStorage.getItem('user')).peran_id) !== 13 && <Typography style={{fontSize: 16, fontWeight: 'bold', color: '#ffffff'}}>{this.props.sekolah.nama} ({this.props.sekolah.npsn})</Typography>}
                                                {/* {Number(JSON.parse(localStorage.getItem('user')).peran_id) !== 13 && <Typography style={{fontSize: 16, fontWeight: 'none', color: '#ffffff'}}>Kepala Sekolah: {this.props.kepala_sekolah.rows[0].nama_kepsek}</Typography>} */}
                                                {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 && <Typography style={{fontSize: 13, fontWeight: 'bold', color: '#ffffff'}}>EDS Dikdasmen untuk Pengawas Sekolah</Typography>}
                                                {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 && <Typography style={{fontSize: 16, fontWeight: 'bold', color: '#ffffff'}}>{this.props.sekolah.nama} ({this.props.sekolah.npsn})</Typography>}    
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 && 
                                                    <Button className="buttonGantiSekolahBinaan" variant="contained" color="primary" onClick={()=>this.props.setDialogSekolahBinaan(true)}><Typography variant="caption" style={{color:'white'}}>Ganti Sekolah</Typography></Button>
                                                }
                                            </Grid>
                                        </Grid>
                                        {/* <Grid container>
                                            <Grid item xs={12} sm={10}>
                                                <Typography style={{fontSize: 16, fontWeight: 'bold', color: '#ffffff'}}>Versi: 2019.12.18</Typography>
                                            </Grid>
                                        </Grid> */}
                                        {/* <Typography style={{fontSize: 16, fontWeight: 'bold', color: '#ffffff', textShadow: '0 0 5px #fff'}}>{this.props.sekolah.nama} ({this.props.sekolah.npsn})</Typography> */}
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Card className={this.props.classes.card + " wadahVersi"} style={{width: '100%', paddingBottom: 0, color: 'white', minHeight: 10, padding: 8}}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6}>
                                                <Typography style={{fontSize: 16, fontWeight: 'bold', color: '#ffffff'}}>Versi: {localStorage.getItem('versi_app')}</Typography>
                                                {/* <Typography style={{cursor:'pointer'}} onClick={()=>this.setState({dialogPerubahan:true})}>Daftar Perubahan</Typography> */}
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6}>
                                                <Button variant="raised" color="secondary" style={{width:'100%'}} onClick={this.hitungTotalRekapKemajuanKandidat}>
                                                    Restore Data dan Hitung Total Kemajuan {this.props.sekolah.nama}
                                                </Button>
                                            </Grid> */}
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Card className={this.props.classes.card} style={{width: '100%', paddingBottom: 0, color: 'white', minHeight: 10, padding: 8}}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12} sm={12} style={{color:'#000000'}}>
                                                Lakukan tarik data bila sekolah Anda pernah mengisi instrumen EDS sebelumnya / baru saja install ulang aplikasi
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button variant="raised" color="primary" style={{width:'100%'}} onClick={()=>this.props.history.push('/Sinkronisasi')}>
                                                    Tarik data dari server
                                                    {/* Tarik data dari server (dahulu: registrasi file prefill) */}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button variant="raised" color="secondary" style={{width:'100%'}} onClick={this.hitungTotalRekapKemajuanKandidat}>
                                                    Restore data dan Hitung Total Kemajuan 
                                                    {/* {this.props.sekolah.nama} */}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 0, backgroundColor: 'rgba(255, 255, 255, .1)', color: 'white', minHeight: 0}}>
                                    {/* <Card className={classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 20, background: 'url(assets/images/bg/full-bloom.png)', minHeight: 0}}> */}
                                    {/* <Card className={classes.card} style={{width: '100%', background: '#2980b9'}}> */}
                                        <CardContent>
                                            <Typography variant="title">Identitas Pengguna</Typography>
                                            <Divider/>
                                            <br/>
                                            <Grid container>
                                                <Grid item xs={3} sm={3} style={{height: 105, border: '0px solid #ccc'}}>
                                                    <Paper className={this.props.classes.paper} style={{width: '100%', height: 80, borderRadius: '5%', background: 'url(http://'+window.location.host+'/assets/images/avatars/avatar.gif)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
                                                        &nbsp;
                                                    </Paper>
                                                </Grid>
                                                {/* <Grid item xs={3} sm={3} style={{height: 100}}>
                                                    <Paper className={this.props.classes.paper} style={{background: 'transparent', textAlign: 'center'}}>
                                                        {/* <br/>
                                                    </Paper>
                                                </Grid> */}
                                                <Grid item xs={9} sm={9} style={{border: '0px solid #ccc'}}>
                                                    <div className="panelDataPengguna">
                                                        <span style={{fontWeight:'bold',fontStyle: 'italic', fontSize: 20, color: '#49ABD4'}} className="namaPertama">{this.state.nama}</span>&nbsp; 
                                                        {/* <span style={{fontWeight: 'bold', fontSize: 20, color: '#49ABD4'}} className="namaPertama">{this.state.namaMarkup[1]}</span>&nbsp; */}
                                                        <EditIcon className={this.props.classes.extendedIcon} style={{color: '#434343', cursor:  'pointer', fontSize: 15}} onClick={this.gotoProfilPengguna}/>
                                                        
                                                        <Typography style={{fontSize: 15, color: '#434343'}}>
                                                            ({this.state.email}) 
                                                            {/* <Chip
                                                                icon={<EditIcon />}
                                                                label="Upgrate"
                                                                className={this.props.classes.chip}
                                                                color="primary"
                                                                style={{justifyContent: 'start'}}
                                                            /> */}
                                                        </Typography>
                                                        <Typography style={{fontSize: 12, color: '#434343'}}>
                                                            {this.state.peran_id_str}
                                                        </Typography>
                                                        {/* <Typography style={{fontSize: 12, color: '#434343'}}>
                                                            {this.props.sekolah.nama}
                                                        </Typography> */}
                                                        {/* <Grid container>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[1]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[2]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[3]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[4]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[5]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[6]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[7]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[8]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[9]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.badgeIndividual}>
                                                                <Button variant="outlined" color="secondary" style={{minWidth:10, minHeight: 10, padding: 2, marginTop: 5, height: 30, width: 30, borderRadius: '50%'}}>
                                                                    <ArrowRightIcon/>
                                                                </Button>
                                                            </Grid>
                                                        </Grid> */}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                
                                <Grid item xs={12} sm={3}>
                                    <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', backgroundColor: 'rgba(255, 255, 255, .1)', minHeight: 190, color: 'white', textAlign: 'center', paddingBottom:5}}>
                                    {/* <Card className={this.props.classes.card} style={{width: '100%', background: '#0984e3'}}> */}
                                        <CardContent style={{paddingBottom:0}}>
                                            <Typography variant="title">Kemajuan Anda</Typography>
                                            <Divider/>
                                            
                                            <List size="small" style={{cursor: 'pointer', color: 'white', width: '100%'}} onClick={this.buatAndaButton}>
                                                {/* <Typography style={{fontSize: 12, color: '#434343'}}>Kemajuan Pengisian Anda</Typography> */}
                                                <div style={{fontSize: 25, color: '#434343', position: 'absolute', top: '35%', margin: 'auto', textAlign: 'center', width: '100%'}}>
                                                    {this.state.persenRata}
                                                    %
                                                </div>
                                                <CircularProgress
                                                // className={classes.progress}
                                                variant={this.state.persenRata ? "determinate" : "indeterminate"}
                                                value={100}
                                                size={120}
                                                thickness={5}
                                                className={classes.progress+" "+classes.facebook2+" mantabs"}
                                                />
                                                <CircularProgress
                                                className={classes.progress+" okesip"}
                                                variant={this.state.persenRata ? "determinate" : "indeterminate"}
                                                value={Number(this.state.persenRata)}
                                                variant="static"
                                                size={120}
                                                thickness={5}
                                                // className={classes.facebook2}
                                                />
                                                {/* <ListIcon className={this.props.classes.extendedIcon} style={{color: 'white'}} />
                                                <Typography style={{color: 'white', paddingLeft: '10px'}}>Selengkapnya</Typography> */}
                                            </List>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 5, backgroundColor: 'rgba(255, 255, 255, .1)', minHeight: 0, color: 'white', textAlign: 'left'}}>
                                        <CardContent>
                                            <Typography variant="title">Penghargaan</Typography>
                                            <Divider/>
                                            <br/>
                                            <Grid container>
                                                {this.props.badge_pengguna.rows.map((option, key)=>{
                                                    let img = option.jenis_badge_id+"_a.png";
                                                    if(option.badge_pengguna_id){
                                                        img = option.jenis_badge_id+".png";
                                                    }

                                                    return(
                                                        <Tooltip title={option.nama + " ("+option.keterangan+")"} key={key}>
                                                            <Grid item xs={2} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+img+')',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                                &nbsp;
                                                            </Grid>
                                                        </Tooltip>
                                                    )
                                                })}
                                                
                                                {/* <Tooltip title="Tooltop">
                                                    <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[1]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                    </Grid>
                                                </Tooltip>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[2]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[3]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[4]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[5]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[6]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[7]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[8]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid>
                                                <Grid item xs={1} className={classes.badgeIndividual} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+this.state.badge_stat[9]+'.png)',backgroundSize:'contain', backgroundPosition: 'bottom',backgroundRepeat:'no-repeat'}}>
                                                </Grid> */}
                                                {/* <Grid item xs={1} className={classes.badgeIndividual} style={{textAlign: 'center'}}>
                                                    <Button variant="outlined" color="secondary" style={{minWidth:10, minHeight: 10, padding: 2, marginTop: 5, height: 30, width: 30, borderRadius: '50%'}}>
                                                        <ArrowRightIcon/>
                                                    </Button>
                                                </Grid> */}
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                
                            </Grid>
                        </div>
                        
                        <Paper className="p-8" style={{background:'url(android_asset/www/assets/images/backgrounds/paper_fibers.png)'}}>
                            {/* <Typography variant="title">
                                Tautan Pintas
                            </Typography>
                            <Divider/>
                            <br/> */}
                            <Grid container>
                                <Grid item sm={5} xs={12}>
                                    <div style={{textAlign: 'left', overflow: 'auto', paddingLeft:'5px', paddingTop: '5px'}}>
                                        {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/ManajemenPengguna')}}>
                                            <AccountCircleIcon style={{fontSize: 40, color: '#00ACC1'}}/>
                                            <br/>Manajemen<br/>Pengguna
                                        </Button>
                                        }
                                        {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/TukarPengguna')}}>
                                            <SyncIcon style={{fontSize: 40, color: '#00897B'}}/>
                                            <br/>Tukar<br/>Pengguna
                                        </Button>
                                        }
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/PerangkatKuesioner')}}>
                                            <AssignmentIcon style={{fontSize: 40, color: '#388E3C'}}/>
                                            <br/>Perangkat<br/>Kuesioner
                                        </Button>
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/Sinkronisasi')}}>
                                            <CheckCircleIcon style={{fontSize: 40, color: '#2196F3'}}/>
                                            <br/>Sinkronisasi
                                        </Button>
                                        {/* <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/PeringkatPengisian')}}>
                                            <AssignmentTurnedInIcon style={{fontSize: 40, color: '#F57C00'}}/>
                                            <br/>Peringkat<br/>Pengisian
                                        </Button> */}
                                        {/* <Button className="p-8 wadahShortcut">variant="outlined" 
                                            <AssignmentIcon style={{fontSize: 40, color: 'green'}}/>
                                            <br/>Pusat<br/>Unduhan
                                        </Button> */}
                                        {/* {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/RaporMutu')}}>
                                            <SyncIcon style={{fontSize: 40, color: '#00897B'}}/>
                                            <br/>Hitung<br/>Rapor Mutu
                                        </Button>
                                        } */}
                                        {/* {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/HasilRaporMutu')}}>
                                            <ClassIcon style={{fontSize: 40, color: '#00897B'}}/>
                                            <br/>Hasil<br/>Rapor Mutu
                                        </Button>
                                        } */}
                                        {/* {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/PaktaIntegritas')}}>
                                            <AssignmentTurnedInIcon style={{fontSize: 40, color: '#00897B'}}/>
                                            <br/>Pakta<br/>Integritas
                                        </Button>
                                        } */}
                                        {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/HasilVerval')}}>
                                            <DoneOutlineIcon style={{fontSize: 40, color: '#00897B'}}/>
                                            <br/>Hasil<br/>Verval
                                        </Button>
                                        }
                                        {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 &&
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/PaktaIntegritas')}}>
                                            <EventNoteIcon style={{fontSize: 40, color: '#1e88e5'}}/>
                                            <br/>Hasil<br/>Supervisi
                                        </Button>
                                        }
                                        <Button className="p-8 wadahShortcut" variant="outlined" onClick={()=>{this.goTolink('/LaporanSaran')}}>
                                            <BookIcon style={{fontSize: 40, color: '#512DA8'}}/>
                                            <br/>Laporan<br/>& Saran
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid item sm={7} xs={12}>
                                    {/* <Paper className="p-16" style={{marginBottom:'8px'}}>
                                        <i>
                                            Aplikasi ini adalah aplikasi versi beta yang berbatas waktu dengan tujuan untuk keperluan simulasi. Setelah tanggal <b>15 Oktober 2020</b>, aplikasi ini akan dinonaktifkan dan tidak dapat digunakan kembali. Silakan tunggu versi rilis resmi aplikasi EDS untuk mengisi instrumen
                                        </i>
                                    </Paper> */}
                                    <Paper className="p-16">
                                        <b>Daftar Pembaruan pada {localStorage.getItem('judul_aplikasi')} {localStorage.getItem('versi_app')}</b>
                                        <ol>
                                            <li>[Pembaruan] Penyesuaian aplikasi pengisian instrumen oleh SPK</li>
                                            <li>[Perbaikan] Proses restore data di beranda setelah registrasi menggunakan prefil</li>
                                            <li>[Perbaikan] Indikator berhasil/gagal ketika proses impor hasil pengisian via offline surveys</li>
                                        </ol>
                                        <br/>
                                        <b>Daftar Pembaruan pada {localStorage.getItem('judul_aplikasi')} 2020</b>
                                        <ol>
                                            <li>[Pembaruan] Pembaruan instrumen tahun 2020</li>
                                            <li>[Pembaruan] Tarik Data dari Aplikasi Dapodik Sekolah</li>
                                            <li>[Pembaruan] Import File Pengisian Instrumen dari Aplikasi offline surveys</li>
                                            <li>[Pembaruan] Konfigurasi akses aplikasi EDS menggunakan jaringan lokal/internet</li>
                                        </ol>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Paper>
                        <div>
                            <div className="section" style={{padding: 8}}>
                                {/* <h1>Such Adorableness</h1> */}
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <br/>
                                        <Typography variant="title" style={{color:'#434343', textAlign: 'left', fontSize: 25}}>
                                                Kemajuan Pengisian Kuesioner PMP
                                        </Typography>
                                        <Typography variant="subheading" style={{color:'#434343', textAlign: 'left'}}>
                                            {this.props.sekolah.nama}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/* <Paper> */}
                                        <Timeline/>
                                        {/* </Paper> */}
                                    </Grid>
                                    <Grid item xs={12} sm={12} className="judulPeringkat">
                                        <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 5, backgroundColor: 'rgba(255, 255, 255, 1)', minHeight: 490, color: 'white', textAlign: 'center'}}>
                                            <CardHeader title="Kemajuan Pengisian Keseluruhan" subheader={this.props.sekolah.nama} classes={{title : classes.judulKemajuanTotal}} style={{fontSize: '18px'}}/>
                                            <Divider/>
                                            <CardContent>
                                                <List style={{width: '100%'}}>
                                                    <div style={{fontSize: 45, color: '#434343', position: 'absolute', top: '35%', margin: 'auto', textAlign: 'center', width: '100%'}}>{this.state.kemajuan_total}%</div>
                                                    <CircularProgress
                                                    // className={classes.progress}
                                                    variant={this.state.kemajuan_total ? "determinate" : "indeterminate"}
                                                    value={100}
                                                    size={205}
                                                    thickness={6}
                                                    className={classes.progress+" "+classes.facebook2}
                                                    />
                                                    <CircularProgress
                                                    className={classes.progress+" okesip"}
                                                    variant={this.state.kemajuan_total ? "determinate" : "indeterminate"}
                                                    value={this.state.kemajuan_total}
                                                    variant="static"
                                                    size={205}
                                                    thickness={6}
                                                    // className={classes.facebook2}
                                                    />
                                                </List>
                                                {/* <Typography style={{fontSize: 17, color: '#434343'}}>Kemajuan Total</Typography> */}
                                                <Typography className="p-16" variant="caption">*Dihitung dari kemajuan pengisian responden, dibandingkan dengan jumlah minimal setiap jenis responden yang harus mengisi</Typography>
                                                <Button size="small" style={{background: '#1abc9c', color: 'white', width: '100%'}} onClick={this.buatSekolahButton}>
                                                    <ListIcon className={this.props.classes.extendedIcon} style={{color: 'white'}} />
                                                    <Typography style={{color: 'white', paddingLeft: '10px'}}>Selengkapnya</Typography>
                                                </Button>

                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={7}>
                                        <PeringkatPengisian />
                                    </Grid> */}
                                </Grid>
                            </div>
                            {/* <div className="section parallax bg2" style={{padding: 8}}>
                                <Grid container spacing={16}>
                                    <Grid item xs={12} sm={5}>
                                    </Grid>
                                    <Grid item xs={12} sm={7}>
                                        <PeringkatPengisian />
                                    </Grid>
                                </Grid>
                            </div> */}
                        </div>
                        {/* <div className="wrapper">
                            <div className="section parallax bg1">
                                <h1>Such Adorableness</h1>
                            </div>
                            <div className="section static">
                                <h1>Boring</h1>
                            </div>
                            <div className="section parallax bg2">
                                tes
                            </div>
                        </div> */}
                    </div>
                    </FuseAnimate>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        getKepalaSekolah: Actions.getKepalaSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getRekapKemajuan: Actions.getRekapKemajuan,
        getBadgePengguna: Actions.getBadgePengguna,
        setLoadingBesar: Actions.setLoadingBesar,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        setKepsekIsiKuesioner: Actions.setKepsekIsiKuesioner,
        pecahJawabanUtama: Actions.pecahJawabanUtama,
        pecahJawabanUtamaSemua: Actions.pecahJawabanUtamaSemua,
        cekJawabanUtamaSemua: Actions.cekJawabanUtamaSemua,
        simpanJawabanUtama: Actions.simpanJawabanUtama,
        simpanJawabanUtamaSemua: Actions.simpanJawabanUtamaSemua,
        simpanJawabanUtamaMandiri: Actions.simpanJawabanUtamaMandiri,
        getPenggunaMengerjakan: Actions.getPenggunaMengerjakan,
        hitungRekapKemajuan: Actions.hitungRekapKemajuan,
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, Pengguna, App }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        rekap_kemajuan: Instrumen.rekap_kemajuan,
        badge_pengguna: Pengguna.badge_pengguna,
        kepsek_isi_kuesioner: App.kepsek_isi_kuesioner,
        dialog_sekolah_binaan: App.dialog_sekolah_binaan,
        kepala_sekolah: App.kepala_sekolah,
        cek_jawaban_utama_semua: Instrumen.cek_jawaban_utama_semua,
        pengguna_mengerjakan: Pengguna.pengguna_mengerjakan
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Beranda)));


// WEBPACK FOOTER //
// ./src/main/content/example/Beranda.js